import {
  Alert,
  Box,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";

const KioskPrint = () => {
  const [visitorId, setVisitorId] = useState("");
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPrintWindowOpen, setIsPrintWindowOpen] = useState(false);

  const handleScan = async (e) => {
    e.preventDefault();
    if (!visitorId || isPrintWindowOpen) return;

    setLoading(true);
    setError("");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/form/users?visitorId=${visitorId}`
      );
      setUserData(response.data);
      handlePrint(response.data);
    } catch (err) {
      setError("Visitor not found or invalid QR");
      setUserData(null);
    } finally {
      setLoading(false);
      setVisitorId("");
    }
  };

  const handlePrint = (user) => {
    const printWindow = window.open();
    const printContent = `
    <html>
 <head></head>
 <body>
   <div style="
     padding: 10px;
     font-family: Arial, sans-serif;
     max-width: 350px;
     height: 400px;
     margin: auto;
     background-color: #f9f9f9;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     text-align: center;
   ">
     <div style="
     margin-top: 200px;
      height: 100%;
       font-size: 16px;
       width: 100%;
       color: #333;
     ">
       <p style="
         font-size: 20px;
         font-weight: 600;
         margin-bottom: 5px;
         word-break: break-word;
       ">
         ${` ${user.firstName} ${user.lastName}`.trim().toUpperCase()}
       </p>
       <p style="
         font-size: 18px;
         margin-bottom: 10px;
         word-break: break-word;
         overflow: "hidden",
   whiteSpace: "nowrap",
   textOverflow: "ellipsis",
   display: "block",  
       ">
         ${user.companyName}
       </p>
       <img 
         src="${user.qrCode}" 
         alt="QR Code" 
         style="width: 150px; height: 150px;" 
       />
     </div>
   </div>

     <script>
          const img = document.querySelector("img");
          if (!img.complete) {
            img.onload = () => {
              window.print();
              window.close();
            };
          } else {
            window.print();
            window.close();
          }
        </script>
 </body>
</html>

   `;
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
  };

// const handlePrint = (user) => {
//     const printContent = `
//     <div style="
//          padding: 10px;
//          font-family: Arial, sans-serif;
//          max-width: 350px;
//          height: 400px;
//          margin: auto;
//          background-color: #f9f9f9;
//          display: flex;
//          flex-direction: column;
//          justify-content: center;
//          align-items: center;
//          text-align: center;
//        ">
//          <div style="
//          margin-top: 200px;
//           height: 100%;
//            font-size: 16px;
//            width: 100%;
//            color: #333;
//          ">
//            <p style="
//              font-size: 20px;
//              font-weight: 600;
//              margin-bottom: 5px;
//              word-break: break-word;
//            ">
//              ${` ${user.firstName} ${user.lastName}`.trim().toUpperCase()}
//            </p>
//            <p style="
//              font-size: 18px;
//              margin-bottom: 10px;
//              word-break: break-word;
//              overflow: "hidden",
//       white-space: nowrap;
//      text-overflow: ellipsis;
//      display: block;
//            ">
//              ${user.companyName}
//            </p>
//            <img
//              src="${user.qrCode}"
//              alt="QR Code"
//              id="qr-img"
//              style="width: 150px; height: 150px;"
//            />
//          </div>
//        </div>
//   `;

//     // const printSection = document.getElementById("print-section");
//     // printSection.innerHTML = printContent;
//     // printSection.style.display = "block";
//     // window.print();
//     // printSection.style.display = "none";
//     const printSection = document.getElementById("print-section");
//     printSection.innerHTML = printContent;
//     printSection.style.display = "block";

//     // Wait for QR code to load
//     const img = document.getElementById("qr-img");
//     if (img && !img.complete) {
//       img.onload = () => {
//         window.print();
//         printSection.style.display = "none";
//       };
//     } else {
//       window.print();
//       printSection.style.display = "none";
//     }
//   };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div id="print-section" style={{ display: "none" }}></div>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Scan QR code to print Badge
      </Typography>

      <form onSubmit={handleScan}>
        <TextField
          label="Scan QR Code / Enter Visitor ID"
          variant="outlined"
          value={visitorId}
          onChange={(e) => setVisitorId(e.target.value.toUpperCase())}
          sx={{ width: 400, mb: 2 }}
          required
          autoFocus
          disabled={isPrintWindowOpen}
        />
      </form>

      {loading && <CircularProgress sx={{ mt: 2 }} />}
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default KioskPrint;
